import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Menu, Headset } from 'lucide-react';

const MarketingHeader = () => {
  const navigate = useNavigate();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const navTo = (path) => {
    navigate(path);
    setMobileNavOpen(false);
  };

  return (
    <div className="landing-header">
      <div className="header-content-landing">
        <div className="header-left-group">
          <div className="header-logo" onClick={() => navTo('/')} style={{ cursor: 'pointer' }}>
            <img src="/lawra-header-logo.png" alt="Lawra" className="header-logo-image" />
          </div>
          <button className="header-hamburger" onClick={() => setMobileNavOpen(!mobileNavOpen)} aria-label="Toggle menu">
            <Menu size={24} />
          </button>
          <nav className={`header-nav${mobileNavOpen ? ' mobile-open' : ''}`}>
            <button className="mobile-nav-close" onClick={() => setMobileNavOpen(false)} aria-label="Close menu">✕</button>
            <Button className="use-cases-nav-link" variant="ghost" onClick={() => navTo('/use-cases')} data-testid="nav-use-cases">
              Use Cases
            </Button>
            <Button className="use-cases-nav-link" variant="ghost" onClick={() => navTo('/tools')} data-testid="nav-tools">
              Tools
            </Button>
            <Button className="use-cases-nav-link" variant="ghost" onClick={() => navTo('/how-it-works')} data-testid="nav-how-it-works">
              How It Works
            </Button>
            <Button className="use-cases-nav-link" variant="ghost" onClick={() => navTo('/pricing')} data-testid="nav-pricing">
              Pricing
            </Button>
            <Button className="use-cases-nav-link" variant="ghost" onClick={() => navTo('/credit-calculator')} data-testid="nav-calculator">
              Savings Calculator
            </Button>
            <Button className="use-cases-nav-link" variant="ghost" onClick={() => navTo('/about')} data-testid="nav-about">
              About Us
            </Button>
            <Button className="sign-in-btn mobile-only-signin" onClick={() => navTo('/auth')} style={{ marginTop: '1rem' }}>
              Sign In
            </Button>
          </nav>
        </div>
        <div className="header-right-actions">
          <a href="mailto:sales@lawra-ai.com?subject=Contact%20Enquiry%20-%20Lawra%20AI&body=Hi%20Lawra%20AI%20Team%2C%0A%0AI%20have%20a%20question%20about%20Lawra%20AI%3A%0A%0A%0A%0AThank%20you" className="support-icon-btn" data-testid="support-icon" aria-label="Contact Support">
            <Headset size={18} />
            <span className="support-online-dot" />
          </a>
          <Button className="sign-in-btn" onClick={() => navigate('/auth')} data-testid="nav-sign-in">
            Sign In
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MarketingHeader;
